import { cn } from '@/lib/cn';
import type { ButtonHTMLAttributes } from 'react';

export function RelationActionButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      {...props}
      className={cn(
        'text-primary hover:text-secondary text-base font-medium transition-colors',
        className,
      )}
    />
  );
}
